// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__13MEN","addWidgetButton":"Header_addWidgetButton__2AHAp","dashboardTabs":"Header_dashboardTabs__2NiXC","active":"Header_active__iNA1a"};